<template>
  <v-container
    v-if="isAdminLoggedIn"
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <PageHeader title="Administration" />

    <v-row>
      <v-col>
        <v-card max-width="300" tile>
          <v-list shaped>
            <v-subheader>ADVERTS</v-subheader>
            <v-list-item-group v-model="selectedAdvertItem" color="primary">
              <v-list-item
                v-for="(item, i) in advertItems"
                :key="i"
                :to="item.link"
                link
              >
                <v-list-item-icon>
                  <v-icon :v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>

        <!-- Email Campaigns Menu -->
        <v-card max-width="300" tile class="mt-4">
          <v-list shaped>
            <v-subheader>EMAIL MARKETING</v-subheader>
            <v-list-item-group v-model="selectedEmailItem" color="primary">
              <v-list-item
                v-for="(item, i) in emailItems"
                :key="i"
                :to="item.link"
                link
              >
                <v-list-item-icon>
                  <v-icon :v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <v-container v-else>
    <v-row>
      <v-col>
        <h1 class="mb-8">
          You are not authorised
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/layout/PageHeader'

export default {
  name: 'Admin',
  components: {
    PageHeader
  },
  data() {
    return {
      selectedAdvertItem: 1,
      advertItems: [
        {
          text: 'Approve adverts',
          icon: 'mdi-clock',
          link: '/admin/approve-adverts'
        }
      ],
      selectedEmailItem: 0,
      emailItems: [
        {
          text: 'Email Campaigns',
          icon: 'mdi-email-outline',
          link: '/admin/email-campaigns'
        }
      ]
    }
  },
  methods: {
    Funcioncall(name) {
      if (name) {
        this[name]()
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    isAdminLoggedIn() {
      return this.$store.state.auth.permissions.admin
    }
  }
}
</script>
